import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  template: `
    <h2 mat-dialog-title>{{ 'ACTION_LISTS.CREATE_ACTION_LIST_DIALOG.TITLE' | translate }}</h2>
    <mat-dialog-content data-cy="create-new-list-dialog-input">
      <mat-form-field>
        <input
          matInput
          [placeholder]="'ACTION_LISTS.CREATE_ACTION_LIST_DIALOG.LIST_NAME' | translate"
          [(ngModel)]="listName"
          (keypress)="keyPressed($event)"
        />
      </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions>
      <app-va-common-button
        [buttonText]="'COMMON.ACTION_LABELS.CREATE' | translate"
        (click)="submit()"
        [disabled]="submitDisabled"
      ></app-va-common-button>
      <button mat-button matDialogClose>{{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}</button>
    </mat-dialog-actions>
  `,
  styleUrls: ['./action-list-dialog.component.scss'],
})
export class CreateListDialogComponent {
  listName: string;

  constructor(public dialogRef: MatDialogRef<CreateListDialogComponent>) {}

  get submitDisabled(): boolean {
    return !this.listName;
  }

  keyPressed(event: KeyboardEvent): void {
    if (event.charCode === 13) {
      // Enter pressed
      this.submit();
    }
  }

  submit(): void {
    if (this.submitDisabled) {
      return;
    }
    this.dialogRef.close(this.listName);
  }
}
